import { useState } from 'react';
import Text from '@atoms/Text';
import Image from '@atoms/Image';
import AccordionItem from './accordionItem';

const Accordion = ({ section }) => {
    const { header, questionBank } = section;
    const [isOpen, setIsOpen] = useState(false);

    const addHashToUrl = () => {
        history.replaceState(null, '', `#${section.id}`);
    };

    const toggleAccordian = () => {
        if (!isOpen) {
            addHashToUrl();
        }
        setIsOpen(!isOpen);
    };

    return (
        <div className="mt-10 duration-1000 ease-in-out transition-height">
            <div className="flex gap-2 pb-5 border-gray-300 border-b-1">
                <div
                    id={section.id}
                    className="flex items-center justify-between flex-grow cursor-pointer scroll-m-20 lg:scroll-m-24"
                    onClick={toggleAccordian}
                >
                    <Text
                        className="h5-medium md:h4-medium text-primary-500 "
                        content={header}
                        htmlTag='h3'
                    />
                    {!isOpen ? (
                        <Image
                            className="!w-4 md:!w-5 transition-all duration-200 ease-linear text-primary-500"
                            src={'/images/newDashboard/arrow-down-black.svg'}
                            alt={'arrow_down'}
                        />
                    ) : (
                        <Image
                            className="!w-4 md:!w-5 text-base font-bold transition-all duration-200 ease-linear transform rotate-180"
                            src={'/images/newDashboard/arrow-down-black.svg'}
                            alt={'arrow_down'}
                        />
                    )}
                </div>
            </div>
            <div className={`mt-6 ml-2 ${isOpen ? 'block' : 'hidden'}`}>
                    {questionBank.map((item, index) => (
                        <div key={index} className="mt-4">
                            <AccordionItem
                                question={item.question}
                                answer={item.answer}
                                subQuestions={item.subQuestions}
                                note={item.note}
                            />
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default Accordion;
